import React, { useState, useMemo, useEffect } from "react";
import NoStatusScreen from "../../dashboard/indexBoxes/NoStatusScreen";
import { Link } from "react-router-dom";
import {
  useDeleteCopyright,
  useFetchAllCopyright,
} from "../../../api/hooks/copyright";
import ContinueModal from "../../NewEditor/ContinueModal";
import { format } from "date-fns";
import Table from "../../Table";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
function InProcessList({ search }) {
  const limit = 8;
  const { t } = useTranslation();
  const { mutate: deleteCopyright } = useDeleteCopyright({
    onSuccess: () => {
      toast.success("Elemento eliminado");
      refetch();
    },
  });
  const [deleteID, setDeleteID] = React.useState(undefined);
  const [currentPage, setCurrentPage] = useState(1);
  const handleNextPage = () => {
    setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage(currentPage - 1);
  };
  const params = useMemo(
    () => ({
      page: currentPage - 1,
      perPage: limit,
      search: search,
      isValidated: false,
    }),
    [currentPage, search]
  );
  const {
    isLoading,
    isFetching,
    data = {},
    error,
    refetch,
  } = useFetchAllCopyright(params);

  return (
    <div className="autoria--table InProcessList">
      <ContinueModal
        toggle={deleteID}
        handleClose={() => setDeleteID(undefined)}
        handleContinue={() => {
          deleteCopyright(deleteID);
          setDeleteID(undefined);
        }}
        confirmationText={t("services.copyright.deleteModal.text")}
        headerText={t("services.copyright.deleteModal.text2")}
        continueButton={t("services.copyright.deleteModal.text2")}
        cancelButton={t("services.copyright.deleteModal.text3")}
      />
      {/* {data?.length > 0 && (
        <table>
          <tr>
            <th>ID</th>
            <th>TÍTULO DE LA OBRA</th>
            <th>AUTOR</th>

            <th>TIPO DE ARCHIVO</th>
            <th></th>
            <th className="empty"></th>
          </tr>
          {data?.map((x, i) => (
            <tr>
              <td className="id">{i + 1}</td>
              <td className="nombre--obra">
                <span>{x?.title}</span>
              </td>
              <td className="nombre--autor">
                {x?.signatureRepresentant?.author || x?.authors?.[0]?.name}
              </td>

              <td className="tipo">{x?.fileType}</td>
              <td className="status">
                {" "}
                <Link
                  className="editButton--autoria"
                  to={`/services/autorship-proof/${x?._id}/edit`}
                >
                  Editar
                </Link>
              </td>
              <td className="status">
                {" "}
                <div
                  className="deleteButton--autoria"
                  onClick={() => setDeleteID(x?.id)}
                >
                  Eliminar
                </div>
              </td>
              <th className="empty"></th>
            </tr>
          ))}
        </table>
      )}
      {(data?.length === 0 || !data.length) && (
        <NoStatusScreen text={"Sin Información para mostrar"} />
      )} */}
      <Table
        paginationData={{
          total: data?.result?.total,
          page: currentPage,
          numPages: Math.ceil(data?.result?.total / limit),
          perPage: 8,
        }}
        onNextPage={handleNextPage}
        onPrevPage={handlePrevPage}
        isLoading={isLoading || isFetching}
        hasError={error}
        actions={"forCopyright"}
        className={"tableForCopyright"}
        EmptyTableProps={{
          primary: "Sin Información para mostrar",
          secondary: "No hay resultados para esta busqueda",
        }}
        columns={[
          {
            header: "ID",
            key: "index",
          },
          {
            header: t("services.copyright.table.inProcessTable.1"),
            key: "name",
            render: (copyright) => {
              return <span className="text-black-50">{copyright?.name}</span>;
            },
          },

          {
            header: t("services.copyright.table.inProcessTable.2"),
            key: "author",
            render: (copyright) => {
              return (
                <span className="text-black-50">
                  {copyright?.signatureRepresentant?.author ||
                    copyright?.authors?.[0]?.name}
                </span>
              );
            },
          },
          {
            header: t("services.copyright.table.inProcessTable.3"),
            key: "fileType",
            render: (copyright) => {
              return (
                <span className="text-black-50">
                  {copyright?.mainmainFileData?.type}
                </span>
              );
            },
          },
          {
            header: "",
            key: "edit",
            render: (copyright) => {
              return (
                <Link
                  className="editButton--autoria"
                  to={`/services/autorship-proof/${copyright?._id}/edit`}
                >
                  {t("services.copyright.table.inProcessTable.edit")}
                </Link>
              );
            },
          },
          {
            header: "",
            key: "delete",
            render: (copyright) => {
              return (
                <div
                  className="deleteButton--autoria"
                  onClick={() => setDeleteID(copyright?._id)}
                >
                  {t("services.copyright.table.inProcessTable.delete")}
                </div>
              );
            },
          },
        ]}
        data={data?.result?.copyrights?.sort(
          (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
        )}
      />
    </div>
  );
}

export default InProcessList;
